var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedCircleCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29156 13.5875C7.11343 13.5875 6.94469 13.5086 6.83063 13.3719L3.83297 9.77348C3.62047 9.5188 3.65563 9.13989 3.90953 8.92817C4.16343 8.71568 4.54156 8.74927 4.75484 9.00473L7.2775 12.0336L13.2291 4.45864C13.4337 4.1977 13.8119 4.15316 14.0712 4.35708C14.3322 4.56176 14.3775 4.93911 14.1728 5.19926L7.76343 13.3579C7.65171 13.5008 7.48139 13.5852 7.30015 13.5875L7.29156 13.5875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedCircleCheck);
export default __webpack_public_path__ + "static/media/completed-circle-check.c5a119517e6c17f2eadbd401be9635ee.svg";
export { ForwardRef as ReactComponent };